
/**
 * @param {HTMLElement} elem
 * @var {HTMLElement} node
 */
function showPopover(elem){
    
    //alert();
    if(!elem) { console.log("popover no element "+elem); return;}
    let text = elem.getAttribute('data-content');
    if(!text) {console.log("popover no attribute"); return;}

    // 
    //
    //fade
    var bounds=elem.getBoundingClientRect(); // + bounds.width +
    var offsetX=bounds.left + window.scrollX;
    var offsetY=bounds.top  + window.scrollY  + bounds.height ;
    

    let html ='<div class="popover bs-popover-right show" role="tooltip" id="thepopover" x-placement="right" style="position: absolute; top: 0px; left: 0px;will-change: transform;"><div class="arrow" style="top: 16px;"></div><h3 class="popover-header-disabled"></h3><div class="popover-body"><div class="popover-content">'+text+'</div></div></div>';
    let dom = new DOMParser()
  .parseFromString(html, 'text/html');

//   console.log(html);
    let node = dom.body.firstElementChild;    

 

    // /** @var {HTMLElement} node*/

    let div = node.ownerDocument.querySelector('div');


    //div.style.transform='translate3d('+offsetX+'px, '+offsetY+'px, 0px)';

    if(window['thepopover']){
        document.getElementById('thepopover').replaceWith(node);
    }else document.body.appendChild(node);
    // console.log( node);
    offsetY -= window['thepopover'].clientHeight/2;

    offsetX-=(node.clientWidth)/2;
    if(window.innerWidth<590){
        offsetX=(window.innerWidth-node.clientWidth)/2;
    }
    window['thepopover'].style.transform='translate3d('+offsetX.toFixed(0)+'px, '+offsetY.toFixed(0)+'px, 0px)';
    window['thepopover'].style.display='block';
}


document.body.querySelectorAll('[data-toggle="popover"]').forEach(function(elem,key,parent){
    elem.addEventListener('click',function(ev){
        showPopover(elem);
        elem.style.outline='none';

        return true;
    });
    // elem.addEventListener('hover',function(ev){showPopover(elem)});
    // console.log(key);

    
});

//first this
document.body.addEventListener('click',function(ev){
    if(window['thepopover'] && ev.target && !ev.target.getAttribute('data-toggle')){
        //document.getElementById('thepopover').remove();
        console.log('remove popover');
        window['thepopover'].style.display='none';
    }
    return false;
})

window.showPopover= showPopover;

export default showPopover;
export {showPopover};